// extracted by mini-css-extract-plugin
export default {"starIcon":"Rate_starIcon__IN9Qw"};